module.exports = __webpack_public_path__ + "img/12.a434a75a.png";